import React, { useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from '@mui/material';
import { Checkbox } from 'primereact/checkbox';
import { PlayCircleFilled } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { styledCheckboxHeader } from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import { ISceneLightShow } from '../../../types/Scenes/scenesTypes';
import { ContainerTable } from '../../locations/locationsList/locationListStyles';
import Strings from '../../../i18n';
import { useExecuteSceneMutation } from '../../../services/scenes/sceneService';

interface IScenesListTemplateProps {
  selectedScenes: any[];
  setSelectedScenes: (selectedScenes: any[]) => void;
  scenes: ISceneLightShow[];
  isLoading: boolean;
}
export const ScenesListLightShowsTemplate = ({
  selectedScenes,
  setSelectedScenes,
  scenes,
  isLoading
}: IScenesListTemplateProps) => {
  const [execute, { isSuccess: isSuccessExecute }] = useExecuteSceneMutation();
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedScenes.length > 0 ? 'visible' : 'hidden',
          ...styledCheckboxHeader
        }}
        checked={selectedScenes.length > 0 || false}
        onChange={() => {
          setSelectedScenes([]);
        }}
      />
    );
  };

  const getActionsColumn = (rowData: ISceneLightShow) => {
    return (
      <div className="d-flex align-items-center my-1">
        <Tooltip title={Strings.scenes.executeThisScene}>
          <PlayCircleFilled
            data-testid="button"
            onClick={(e) => {
              e.stopPropagation();
              execute(rowData.sceneId || 0);
            }}
            style={{ cursor: 'pointer', zIndex: 300 }}
          />
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    if (isSuccessExecute) {
      toast.success(Strings.scenes.successExecuteScene);
    }
  }, [isSuccessExecute]);

  return (
    <>
      {isLoading && <LoadingRowsComponent />}
      {!isLoading && scenes && (
        <ContainerTable component="main">
          <DataTable
            rowHover
            selection={selectedScenes}
            onSelectionChange={(e) => {
              setSelectedScenes([e.value]);
            }}
            className="mt-3"
            value={scenes}
            size="small"
            scrollable
            scrollHeight="flex"
            paginator={scenes && scenes.length >= 50}
            selectionPageOnly
            rows={50}
            metaKeySelection
            rowsPerPageOptions={[5, 10, 20, 50, scenes ? scenes.length : 50]}
            tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          >
            <Column selectionMode="single" frozen />
            <Column field="sceneId" header="Id" sortable />
            <Column field="name" header="Name" sortable />
            <Column field="sceneIndex" header="Scene Index" sortable />
            <Column field="actionCount" header="Action Count" sortable />
            <Column field="" header="Actions" body={getActionsColumn} />
          </DataTable>
        </ContainerTable>
      )}
    </>
  );
};
